
function getColor(value) {
    if (value >= 0) {
        // Define the start and end colors for green gradient (0-10 range)
        let startGreen = [99, 240, 157]; // #63f09d
        let endGreen = [61, 111, 80]; // #3d6f50
        
        let ratio = Math.min(value / 10, 1); // Clamp ratio between 0 and 1
        let green = startGreen.map((start, i) => Math.round(start + (endGreen[i] - start) * ratio));
        
        return `rgb(${green[0]}, ${green[1]}, ${green[2]})`;
    } else {
        // Define the start and end colors for red gradient (-10 to 0 range)
        let startRed = [255, 200, 200]; // Light red
        let endRed = [255, 0, 0]; // Dark red
        
        let ratio = Math.min(Math.abs(value) / 10, 1); // Clamp ratio between 0 and 1
        let red = startRed.map((start, i) => Math.round(start + (endRed[i] - start) * ratio));
        
        return `rgb(${red[0]}, ${red[1]}, ${red[2]})`;
    }
}



function getColorByNumber(value) {
    if (value >= 20) return "#13ac59"; // Max positive
    if (value <= -10) return "#C4191C"; // Max negative

    if (value > 0) {
        return interpolateColor(value, 0, 14, "#084222", "#0e783e", "#13ac59");
    } else if (value < 0) {
        return interpolateColor(value, -10, 1, "#C4191C", "#DB0F07");
    }
    return "#6b7280"; // Neutral gray for zero EV
}

function interpolateColor(value, min, max, startColor, midColor, endColor) {
    const normalize = (value - min) / (max - min);
    
    if (normalize <= 0.5) {
        return mixColors(startColor, midColor, normalize * 2);
    } else {
        return mixColors(midColor, endColor, (normalize - 0.5) * 2);
    }
}

function mixColors(color1, color2, ratio) {
    const hex = (color) => parseInt(color?.slice(1), 16);
    const r = (color) => (hex(color) >> 16) & 255;
    const g = (color) => (hex(color) >> 8) & 255;
    const b = (color) => hex(color) & 255;
    
    const mix = (c1, c2) => Math.round(c1 * (1 - ratio) + c2 * ratio);
    
    const rMixed = mix(r(color1), r(color2));
    const gMixed = mix(g(color1), g(color2));
    const bMixed = mix(b(color1), b(color2));
    
    return `#${((1 << 24) | (rMixed << 16) | (gMixed << 8) | bMixed).toString(16)?.slice(1)}`;
}





export const EVPercent = (props) => {
	const { ev } = props;

    // let colour = getColor(ev)
    let colour = getColorByNumber(ev)

	return (
		<div style={{textAlign: "center"}}>
			<div style={{backgroundColor: colour, color: 'white'}} className="p-2 rounded">{ev?.toFixed(2)}%</div>
		</div>
	);
};
